import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DynamicViewService } from '@sasser/sfh-agentic-ui';
import { detectBody } from '../../../app.helpers';
import { Rail360CatalogDocumentComponent } from '../../../agentic/catalog/rail360-catalog-document.component';
import { FooterComponent } from '../footer/footer.component';
import { NavigationComponent } from '../navigation/navigation.component';
import { TopNavbarComponent } from '../navigation/topnavbar/topnavbar.component';

declare var jQuery:any;

@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DialogModule,
    Rail360CatalogDocumentComponent,
    FooterComponent,
    NavigationComponent,
    TopNavbarComponent
  ],
  selector: 'basicLayout',
  templateUrl: 'basicLayout.template.html',
  styleUrl: 'basicLayout.component.scss',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class BasicLayoutComponent {
  readonly dynamicView = inject(DynamicViewService);

  constructor() {
    // An assistant-composed view would otherwise keep covering the routed page, because
    // the router outlet stays hidden for as long as a document is active.
    inject(Router).events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => this.dynamicView.dismiss());
  }

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }
}
